import { useState, ReactNode, useRef, useEffect } from 'react';
import {
  FilterHeader,
  TableOptionsContainer,
  TableSelect,
} from './styles/AXSTableSelect.styled';
import { ChevronDownFilled } from '@fluentui/react-icons';

interface AXSTableSelectProps {
  header: string;
  children: ReactNode;
  inputStylePicker?: boolean;
  right?: string;
  width?: string;
  closeAllFilters?: () => void;
  scrollable?: boolean;
  position?: string;
  optionContainerPadding?: string;
  filterOptionsHeader?: string;
  left?: string;
}

export const AXSTableSelect = ({
  closeAllFilters,
  header,
  children,
  inputStylePicker,
  position,
  right,
  left,
  width,
  scrollable = false,
  optionContainerPadding,
  filterOptionsHeader,
}: AXSTableSelectProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  const handleClickOutside = (event: MouseEvent | TouchEvent) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsOpen(false);
      closeAllFilters && closeAllFilters();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);
  return (
    <TableSelect
      onClick={() => setIsOpen(true)}
      inputStylePicker={inputStylePicker}
      position={position}
    >
      {header}&nbsp;
      <ChevronDownFilled />
      {isOpen && (
        <TableOptionsContainer
          right={right}
          left={left}
          width={width}
          ref={ref}
          scrollable={scrollable}
          optionContainerPadding={optionContainerPadding}
        >
          {filterOptionsHeader && (
            <FilterHeader>{filterOptionsHeader}</FilterHeader>
          )}

          {children}
        </TableOptionsContainer>
      )}
    </TableSelect>
  );
};
